/**
 * All JavaScript required for card
 *
 * @component card
 */

class card {

    constructor(){
        let self = this;
        self.attachEventHandlers();
    }

    attachEventHandlers() {
        let self = this;

        // open via link
        $('body').on('click', '[data-card]', function(e){
            let cardId = $(this).data('card');
            let $card = self.getCardById(cardId)
            if ($card !== false) {
                e.preventDefault();
                self.toggleCard($card);
                return false;
            }
        });

        // close
        $('body').on('click', '[data-card-close]', function(e){
            let $card = $(this).parents('.c-card').first();
            self.toggleCard($card);
        });

        // close a closable
        $('[data-close]').on('click', function(e){
            let $card = $(this).parents('[data-closable]').first();
            self.toggleCard($card);
        });
    }

    // find a card by ID attribute
    getCardById(cardId) {
        if (cardId === undefined || cardId === null || cardId === '') return false;
        let $card = $('#'+cardId);
        if ($card.length === 0) {
            if (window.console) window.console.log('card not found: #'+cardId);
            return false;
        }
        return $card;
    }

    // toggle a $card (jquery object)
    toggleCard($card) {
        let self = this;
        // @TODO rewrite this to use CSS transitions!
        if ($card.is(':visible')) {
            $card.fadeOut();
        } else {
            $card.fadeIn();
        }
    }

}

export default new card();
